import html from "./html";
import isLive from "./isLive";
import language from "./language";
import lastVisitedNode from "./lastVisitedNode";
import {onReady, onReadyRun} from "./onReady";

// Avoid overwrite
const _gg = typeof _gg == "object" ? _gg : {};

if (typeof _gg.onReady == "undefined") {
    _gg.onReady = onReady;
}

if (typeof _gg.onReady.body == "undefined") {
    _gg.onReady.body = () => {
        _gg.body = document.body;
    }
}

if (typeof _gg.html == "undefined") {
    _gg.html = html;
}

if (typeof _gg.isLive == "undefined") {
    _gg.isLive = isLive;
}

if (typeof _gg.language == "undefined") {
    _gg.language = language;
}

if (typeof _gg.lastVisitedNode == "undefined") {
    _gg.lastVisitedNode = lastVisitedNode;
}

if (typeof _gg.onReadyRun == "undefined") {
    _gg.onReadyRun = onReadyRun;
}

window._gg = _gg;
